import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import Menu from "../../component/main_menu"
import { formatDate } from "../../utils/format_date"
import { useAuthContext } from '../../common/ProtectedLayout';

function Cost(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const [reserveList, setReserveList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const auth = useAuthContext();

    const getPriceInfo = async () => {
        try {
            const reserve_result = await axios.get('/PriceInfo');
            setReserveList(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };

    const addManager = () => {
        navigate('/addmanager');
    }

    useEffect(() => {
        setIsValidAccess(true);
        getPriceInfo();
    }, [location.state, navigate]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <div style={{ marginTop: '50px' }}>
                    <CommonTable headerTitle={['No', '작업종류', '기본가격', '추가수당', '천정고', '냉난방', '공기청정', '리프트', '할인율1', '할인율2', '할인율3']}>
                        {
                            reserveList.slice(items * (page - 1), items * (page - 1) + items).map((reserve, index) => {
                                return (
                                    <CommonTableRow key={index} idx={reserve.idx} beforePage={'/cost'} kind={'cost'}>
                                        <CommonTableColumn>{reserveList.length - ((page - 1) * 10) - index}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.kind}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.base_price}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.add_price}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.height}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.heating}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.clearing}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.lift}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.sale_percent_1}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.sale_percent_2}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.sale_percent_3}</CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>
                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={reserveList.length}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>
        </div >
    );
}

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

export default Cost;